/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {configureStore} from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import {Provider, TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import {authReducer} from "./reducers/auth-reducer";
import {drawerReducer} from "./reducers/drawers-reducer";
import {reloadSignalReducer} from "./reducers/reloadsignal-reducer";


export const store = configureStore({
    reducer: {
        auth: authReducer,
        drawer: drawerReducer,
        reloadSignals: reloadSignalReducer,
    },
    middleware: [thunk],
})

type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default function AppStore({children}: { children: JSX.Element }) {
    return (
        <Provider store={store}>
            {children}
        </Provider>
    )
}
